(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xterm")["Terminal"]);
	else if(typeof define === 'function' && define.amd)
		define("XtermPlayer", [["xterm","Terminal"]], factory);
	else if(typeof exports === 'object')
		exports["XtermPlayer"] = factory(require("xterm")["Terminal"]);
	else
		root["XtermPlayer"] = factory(root["Terminal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 